var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.6,
    y: 25.8,
    width: 28.8,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9,
    y: 25.8,
    width: 23,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9,
    y: 54.6,
    width: 23,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9,
    y: 40.2,
    width: 23,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.6,
    y: 69.2,
    width: 63.4,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.6,
    y: 97.3,
    width: 63.4,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.6,
    y: 82.9,
    width: 63.4,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,7.3V123H109V7.3H15.2z M103.2,117.2H20.9V13.1h82.3V117.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.4d507c000ae96c38cea9ba6f92df7808.svg";
export { ForwardRef as ReactComponent };